// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rf4y5","title":"styles_title__dacJ+","children":"styles_children__TRSSq"};